module.exports = __webpack_public_path__ + "img/gx_icon.73ffb73.png";